// extracted by mini-css-extract-plugin
export default {"settings":"KWuwJ1qMgwUircHukGmn","container":"H9Byvza8E2TPm9c8q_U0"};